var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Tokens/Walletconnect"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Box",
    cx: 12,
    cy: 12.1946,
    r: 12,
    fill: "#3B99FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7245 9.14841C14.1152 6.54331 9.88479 6.54331 7.27553 9.14841L6.93086 9.49253C6.8004 9.62279 6.8004 9.83397 6.93086 9.96423L8.00509 11.0367C8.07032 11.1019 8.17608 11.1019 8.24131 11.0367L8.7041 10.5747C10.5244 8.75731 13.4756 8.75731 15.2959 10.5747L15.7281 11.0061C15.7933 11.0713 15.8991 11.0713 15.9643 11.0061L17.0385 9.93363C17.169 9.80337 17.169 9.59219 17.0385 9.46193L16.7245 9.14841ZM19.9022 12.321L18.9461 11.3665C18.8156 11.2362 18.6041 11.2362 18.4736 11.3665L15.414 14.4213C15.3814 14.4538 15.3285 14.4538 15.2959 14.4213L12.2362 11.3664L12.2362 11.3664C12.1057 11.2362 11.8942 11.2362 11.7637 11.3664L8.70418 14.4213C8.67156 14.4538 8.61868 14.4538 8.58606 14.4213L5.52636 11.3664C5.3959 11.2362 5.18438 11.2362 5.05391 11.3664L4.09785 12.321C3.96738 12.4512 3.96738 12.6624 4.09785 12.7927L8.40893 17.0969C8.5394 17.2271 8.75092 17.2271 8.88138 17.0969L11.941 14.0421C11.9736 14.0095 12.0265 14.0095 12.0591 14.0421L15.1187 17.0969C15.2492 17.2271 15.4607 17.2271 15.5912 17.0969L19.9022 12.7927C20.0326 12.6625 20.0326 12.4513 19.9022 12.321Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/Walletconnect.8e3c90c11c7c1adebf3f835395aae42a.svg";
export { ForwardRef as ReactComponent };